import React, {useEffect, useState} from 'react';
import styles from './Field.module.css';
import imageCompression from "browser-image-compression";
import useFileCompression from "../../hooks/useFileCompression";
import {
    renameFileJustificatif,
    saveFile,
    deleteJustificatif,
    reassignmentJustificatif, downloadFile
} from "../../services/FileService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faExclamation, faEye, faPlus, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {useUser} from "../../contexts/UserContext";
import loginForm from "../Login/LoginForm";
import AxiosConfig from "../../services/AxiosConfig";
import {useModal} from "../../contexts/ModalContext";
import { ReactComponent as SupprimerIcon } from '../../icons/supprimer.svg';


const FieldUpload = ({ label, name, id = name, value, data, titleExclamation = "", actif = true, onSuccess = null }) => {
    const { user } = useUser();
    const { compressFile } = useFileCompression();
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [fichier, setFichier] = useState(reassignmentJustificatif(""));
    const { showModal, hideModal } = useModal();

    const handleSuccess = (children = "Succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        if (value) {
            setFichier(reassignmentJustificatif(value));
        }
    }, [value]);

    useEffect(() => {
        if (fichier) {
            const fileName = fichier.file.split('/').pop();
            setUploadedFileName(fileName);
        }
    }, [fichier]);

    const handleFileChange = async (event) => {
        const file = event.target.files[0];

        if (!file) return;

        const compressedFile = await compressFile(file);

        if (compressedFile.size < 2097152) {
            const savedFile = await saveFile(compressedFile, data.justificatifType);
            const fileInputLabel = document.querySelector(`label[for="${event.target.id}"] span`);

            if (fileInputLabel) {
                setUploadedFileName(fileInputLabel.textContent);
            }
            if (savedFile.success && onSuccess) onSuccess(savedFile.message);
        } else {
            console.error("Fichier trop volumineux");
        }
    };

    const handleFileClick = async (event) => {
        const rez = await downloadFile(fichier);
        if (rez.success) {
            handleSuccess(rez.message);
        } else {
            handleError(rez.message);
        }
    };

    const handleDelete = async () => {
        const fetchThat = async () => {
            if (fichier && fichier.id) {
                const response = await deleteJustificatif(fichier.id);
                if (response.success) {
                    handleSuccess(response.message);
                    setUploadedFileName("");
                } else {
                    handleError(response.message);
                }
            }
        }

        showModal('confirm', {
            message: "Êtes-vous sûr de vouloir supprimer ce document ?",
            onConfirm: fetchThat,
        });
    };

    let uploadClassNames =  styles.fileUploadContainer;
    data.justificatifActif ? uploadClassNames += " " :  uploadClassNames += " "+styles.fileUploadContainerDisabled;

    return (
        <div className={uploadClassNames} title={ !data.justificatifActif ? "Inactif" : null }>
            {!uploadedFileName || actif === false ? (
                <>
                    <input
                        type="file"
                        id={id}
                        className={styles.fileUploadInput}
                        onChange={handleFileChange}
                        hidden
                        name={name}
                    />
                    <label htmlFor={id} className={styles.fileUploadLabel}>
                        <div className={styles.fileUploadButton}>
                            <>
                                <FontAwesomeIcon icon={faPlus} className={styles.fileUploadIcon}/>
                                <span className={styles.fileUploadText}>{label}</span>
                            </>
                        </div>
                    </label>
                </>
            ) : (
                <>
                    <button className={styles.fileTrashBtn} onClick={handleDelete}>
                        <SupprimerIcon className={styles.fileUploadIcon}/>
                    </button>
                    <input
                        type={"button"}
                        id={id}
                        className={styles.fileUploadInput}
                        onClick={handleFileClick}
                        hidden
                        name={name}
                    />
                    <label htmlFor={id} className={styles.fileUploadLabel}>
                        <div className={styles.fileUploadButton}>
                            <>
                                <FontAwesomeIcon className={styles.fileUploadedIcon} icon={faCheck}/>
                                <span className={styles.fileUploadMsgLabel}>{label}</span>
                            </>
                        </div>
                    </label>
                </>
            )}
            {
                ((fichier && fichier.type.obligatoire) || (data && data.justificatifObligatoire)) &&
                <div className={styles.fileExclamationContainer} title={"Obligatoire"}>
                    <span className={styles.fileExclamation} title={titleExclamation}>
                        <FontAwesomeIcon icon={faExclamation} className={styles.fileUploadIcon} title={"Obligatoire"}/>
                    </span>
                    <span>{titleExclamation}</span>
                </div>
            }
        </div>
    )
        ;
};
export default FieldUpload;
